import classes from "./Video.module.css";

const Video = () => {
  return (
    <div className={classes.videoContainer}>
      <iframe
        className={classes.videoFrame}
        src="https://www.youtube.com/embed/sEJbsVTg2q4?autoplay=1&mute=1&loop=1&playlist=sEJbsVTg2q4"
        title="YouTube video player"
        frameBorder="0"
        allow="autoplay; encrypted-media"
        allowFullScreen
      ></iframe>
    </div>
  );
};

export default Video;
